import React from 'react'
import PropTypes from 'prop-types'
import { Title, Text, Input, Button } from 'components'
import styles from './PartnershipSearch.module.scss'

const PartnershipSearch = ({
  fetchData,
  buttonDisplay,
  onChange,
  value,
  handleSearch,
}) => (
  <div className={styles.main}>
    <header className={styles.header}>
      <Title type="h1" fontSize="xlarge">
        Consulte aqui quem pode atuar na venda dos nossos imóveis
      </Title>
      <Text fontSize="medium" color="darkBlueColor">
        Confira sempre se você está comprando com alguém que pode atuar na venda
        dos nossos imóveis.
      </Text>
    </header>
    <Input
      className={styles.input}
      id="find-by-id"
      onChange={e => onChange(e.target.value)}
      value={value}
      icon="search"
      type="text"
      placeholder="Buscar por Nome, Tipo de canal (imobiliária, corretor, leiloeiro), Cidade, Estado ou Banco"
      round
      onSearch={handleSearch}
    />
    {buttonDisplay && (
      <Button
        onClick={() => fetchData(true)}
        type="filled"
        fontSize="medium"
        className={styles.buttonSearch}
      >
        Buscar
      </Button>
    )}
  </div>
)

PartnershipSearch.propTypes = {
  fetchData: PropTypes.func.isRequired,
  buttonDisplay: PropTypes.bool.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  handleSearch: PropTypes.func.isRequired,
}

export default React.memo(PartnershipSearch)
